var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 329"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 74",
    x1: 0.493896,
    y1: 2.42025,
    x2: 28.2847,
    y2: 2.42025,
    stroke: "#020732",
    strokeWidth: 3.1595
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 76",
    x1: 0.493896,
    y1: 13.9205,
    x2: 28.2847,
    y2: 13.9205,
    stroke: "#020732",
    strokeWidth: 3.1595
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 75",
    x1: 0.493896,
    y1: 25.4205,
    x2: 28.2847,
    y2: 25.4205,
    stroke: "#020732",
    strokeWidth: 3.1595
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.a0e69070de181186f3edcf3ed7e6b9e0.svg";
export { ForwardRef as ReactComponent };